<template>
  <div class="page-container">
    <v-container>
      <v-row>
        <v-col cols="12">
          <!-- Hero Section -->
          <div class="hero-section mb-6">
            <h1 class="text-h4 font-weight-bold mb-2">Comparativas Tech 2026</h1>
            <p class="text-subtitle-1 grey--text text--darken-1">
              Análisis detallado para elegir las mejores herramientas según tu stack y
              necesidades.
            </p>
          </div>

          <v-divider class="my-6"></v-divider>

          <!-- Navegación rápida -->
          <v-card class="pa-4 mb-6" elevation="1">
            <h3 class="text-h6 font-weight-medium mb-3">📌 Ir a comparativa</h3>
            <v-chip-group>
              <v-chip
                v-for="(comp, index) in comparativas"
                :key="index"
                @click="scrollTo(comp.id)"
                class="mr-2"
                outlined
              >
                {{ comp.title }}
              </v-chip>
            </v-chip-group>
          </v-card>

          <!-- Comparativa 1: Editores -->
          <div :id="comparativas[0].id" class="comparativa-section mb-8">
            <h2 class="text-h5 font-weight-medium mb-4">1. Editores de código</h2>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Característica</th>
                  <th>VS Code</th>
                  <th>Sublime Text</th>
                  <th>IntelliJ IDEA</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Precio</td>
                  <td>Gratuito</td>
                  <td>$99 (licencia perpetua)</td>
                  <td>$169/año (Ultimate)</td>
                </tr>
                <tr>
                  <td>Mejor para</td>
                  <td>Web, JavaScript, Python</td>
                  <td>Edición rápida</td>
                  <td>Java, Kotlin, empresarial</td>
                </tr>
                <tr>
                  <td>Extensiones</td>
                  <td>+50,000</td>
                  <td>Limitado</td>
                  <td>Extenso ecosistema</td>
                </tr>
                <tr>
                  <td>Rendimiento</td>
                  <td>Bueno</td>
                  <td>Extremadamente rápido</td>
                  <td>Pesado pero potente</td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-alert type="info" class="mt-3"
              ><strong>Recomendación:</strong> VS Code para versatilidad, IntelliJ para
              Java, Sublime para rapidez.</v-alert
            >
          </div>

          <!-- Comparativa 2: Frameworks -->
          <div :id="comparativas[1].id" class="comparativa-section mb-8">
            <h2 class="text-h5 font-weight-medium mb-4">2. Frameworks frontend</h2>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Característica</th>
                  <th>React</th>
                  <th>Vue.js</th>
                  <th>Angular</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Curva de aprendizaje</td>
                  <td>Media</td>
                  <td>Baja</td>
                  <td>Alta</td>
                </tr>
                <tr>
                  <td>Popularidad 2025</td>
                  <td>#1</td>
                  <td>#3</td>
                  <td>#4</td>
                </tr>
                <tr>
                  <td>Ecosistema</td>
                  <td>Extenso (Next.js)</td>
                  <td>Bueno (Nuxt.js)</td>
                  <td>Completo</td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-alert type="info" class="mt-3"
              ><strong>Recomendación:</strong> Vue.js para rapidez, React para
              empleabilidad, Angular para estructura.</v-alert
            >
          </div>

          <!-- Comparativa 3: Bases de datos -->
          <div :id="comparativas[2].id" class="comparativa-section mb-8">
            <h2 class="text-h5 font-weight-medium mb-4">3. Bases de datos</h2>
            <v-simple-table>
              <thead>
                <tr>
                  <th>Característica</th>
                  <th>PostgreSQL</th>
                  <th>MySQL</th>
                  <th>MongoDB</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Tipo</td>
                  <td>Relacional (SQL)</td>
                  <td>Relacional (SQL)</td>
                  <td>NoSQL (documentos)</td>
                </tr>
                <tr>
                  <td>Rendimiento</td>
                  <td>Excelente en consultas complejas</td>
                  <td>Rápido en lectura</td>
                  <td>Alto en escritura</td>
                </tr>
                <tr>
                  <td>Escalabilidad</td>
                  <td>Vertical</td>
                  <td>Vertical</td>
                  <td>Horizontal nativa</td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-alert type="info" class="mt-3"
              ><strong>Recomendación:</strong> PostgreSQL por robustez, MySQL para apps
              web simples, MongoDB para datos cambiantes.</v-alert
            >
          </div>

          <p class="text-caption text-center mt-6 grey--text">
            *Comparativas actualizadas en marzo de 2026. Las características pueden variar
            según versiones.
          </p>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PaginaComparativasTech",
  data() {
    return {
      comparativas: [
        { id: "editores", title: "Editores de código" },
        { id: "frameworks", title: "Frameworks frontend" },
        { id: "bases-datos", title: "Bases de datos" },
      ],
    };
  },
  methods: {
    scrollTo(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.page-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 80px 20px 40px;
}
.hero-section {
  text-align: center;
}
.comparativa-section {
  scroll-margin-top: 90px;
}
th {
  background-color: #f5f7fa;
  font-weight: 600;
  padding: 12px;
}
td {
  padding: 10px;
  border-bottom: 1px solid #e8eef2;
}
</style>
